import { React, useState, useEffect } from "react";
import { Box, Typography, Dialog, DialogContent } from "@mui/material";
import SelectPropertyType from "../select-property/SelectPropertyType";
import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../../config/ApiConfig";
import { errorMessage } from "../../lib/helper";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/sem-fundo.png";
import { useTranslation } from "react-i18next";
import { STATUS_200, STATUS_300 } from "../../data/constants";

const SelectPropertyDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [propertySubCat, setPropertySubCat] = useState([]);
  const getPropertySubCategoryType = async () => {
    try {
      const response = await axios.get(`${ApiConfig.authPropertySubCat}/1`);
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        setPropertySubCat(response.data);
        return response?.data?.data;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return null;
    }
  };

  useEffect(() => {
    if (open) {
      getPropertySubCategoryType();
    }
  }, [open]);

  return (
    <>
     
      <Dialog
        maxWidth="md"
        open={open}
        onClose={onClose}
        className="filter-dialog-product-search"
        aria-labelledby="category-filter-dialog"
        sx={{ maxHeight: "calc(100% - 12px) !important" }}
      >
        <DialogContent>
          <Box component="div" className="looking-for-container">
            <Box component="div" className="looking-for-splitter">
              <Box
                component="div"
                sx={{ maxHeight: "calc(100% - 0px)", height: "100%" }}
              >
                <Box color="white" sx={{ height: "100%" }}>
                  <Box
                    sx={{
                      height: "550px",

                      p: 0,
                      backgroundImage: "url('./assets/img/unsplash-select-property.png')",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  >
                    <Box
                      component="div"
                      className="splitter-container property-type-splitter"
                    >
                      <Link to="/">
                        <img src={Logo} alt="i-moz-logo"  className="logo-img"/>
                      </Link>
                      <Typography
                        variant="xxlSize"
                        className="line-h-condensed-1 buy-sell-text"
                        component="h4"
                        sx={{
                          maxWidth: "calc(100% - 100px)",
                          margin: "12px 0",
                        }}
                      >
                        {t("LogIn.BuySellText")}
                        <Typography
                          component="span"
                          variant="xxlSize"
                          className="text-danger font-great-vibes line-h-condensed-1"
                        >
                          {" "}
                          {t("LogIn.FastestWay")}
                        </Typography>
                      </Typography>
                      <Typography sx={{ maxWidth: "calc(100% - 110px)" }}>
                        {t("LogIn.BuySellText")}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box component="div" className="looking-for-property-type">
              <SelectPropertyType
                onClose={onClose}
                PropertyCat={propertySubCat}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SelectPropertyDialog;
